<template>
  <main class="invitation pt-64">
    <div class="container">
      <div class="main-content text-center">
        <h1 class="text-2xl font-bold whitespace-pre-line">{{ $t('invitation.title') }}</h1>
        <button
          class="btn btn-blue-light btn-solid no-underline mb-16 rounded-full"
          @click="onInviteClick">{{ $t('loginAndInviteFriends') }}</button>
        <p class="mb-40 text-sm text-grey-darker">
          {{ $t('notHavingAccount') }}
          <button @click="goSignUp" class="text-blue cursor-pointer outline-none">{{ $t('signUpNow') }}</button>
        </p>
      </div>

      <div class="steps-content border-1 border-grey-lightest rounded mb-24">
        <div class="how-to-work p-24 pb-8">
          <h3 class="text-grey-darkest font-bold text-lg mb-24">{{ $t('inviteToRebate.threeSteps.title') }}</h3>
          <p class="text-sm text-grey-darker leading-normal whitespace-pre-line">{{ $t('inviteToRebate.threeSteps.desp') }}</p>
          <p class="leading-normal mt-16 md:mt-24 text-sm text-grey-darker flex items-start">
            <span class="whitespace-pre-line">{{ $t('inviteToRebate.threeSteps.duration') }}</span>
          </p>
          <div class="how-to-work__steps flex flex-wrap -mx-16 mt-32">
            <div class="how-to-work__steps__step w-full md:w-1/2 lg:w-1/3">
              <figure>
                <img src="@/assets/images/invitation-step-1.svg" alt="">
              </figure>
              <h4>{{ $t('inviteToRebate.threeSteps.step.0.title') }}</h4>
              <p>{{ $t('inviteToRebate.threeSteps.step.0.desp') }}</p>
            </div>
            <div class="how-to-work__steps__step w-full md:w-1/2 lg:w-1/3">
              <figure>
                <img src="@/assets/images/invitation-step-2.svg" alt="">
              </figure>
              <h4>{{ $t('inviteToRebate.threeSteps.step.1.title') }}</h4>
              <p>{{ $t('inviteToRebate.threeSteps.step.1.desp') }}</p>
            </div>
            <div class="how-to-work__steps__step w-full md:w-1/2 lg:w-1/3">
              <figure>
                <img src="@/assets/images/invitation-step-3.svg" alt="">
              </figure>
              <h4>{{ $t('inviteToRebate.threeSteps.step.2.title') }}</h4>
              <p>{{ $t('inviteToRebate.threeSteps.step.2.desp') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Invitation',
  metaInfo () {
    return {
      title: '推薦回饋',
      meta: [
        {
          'property': 'og:title',
          'content': '推薦回饋',
          'vmid': 'og:title'
        }
      ],
      script: [
        {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': '推薦回饋'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'user/isLogin'
    ])
  },
  methods: {
    ...mapActions([
      'user/goLogin'
    ]),
    onInviteClick: function () {
      this['user/isLogin']
        ? this.$router.push({ name: 'UserPointsInvitation' })
        : this['user/goLogin']()
    },
    goSignUp: function () {
      this.$gtm.trackEvent({
        event: 'onClickRegister',
        category: 'User Click Register'
      })
      this['user/isLogin']
        ? this.$router.push({ name: 'UserPointsInvitation' })
        : window.open(`${process.env.VUE_APP_API}/v2/auth/register`, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
.main-content
  h1
    line-height: 36px
    @apply mb-32

.steps-content
  @apply mx-auto
  max-width: 728px
  .how-to-work
    &__steps
      &__step
        @apply px-16
        figure
          @apply mb-16
        h4
          @apply font-bold mb-16
        p
          @apply text-grey-darker text-base leading-normal
        &:not(:last-of-type)
          @apply mb-16
</style>
